// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2ixJS","title":"ClientCherryInfo_title__2WnQW","itemText":"ClientCherryInfo_itemText__2tRil"};